<div class="title-bar">
	<nav aria-label="breadcrumb">
		<ol class="breadcrumb">
			<li class="breadcrumb-item">
				<fa-icon [icon]="ac.sectionIcons.licensing" class="cp-admin-nav-item me-1" size="sm">
				</fa-icon>
				Key Search
			</li>
			<li *ngIf="activation" class="breadcrumb-item">
				<a href="javascript:void(0)" (click)="onCancel()">{{ activation.key }}</a>
			</li>
			<li class="breadcrumb-item active" aria-current="page">Write Access</li>
		</ol>
	</nav>
</div>

<div *ngIf="loading || saving" style="text-align: center;">
	<app-loading-spinner></app-loading-spinner>
</div>

<form *ngIf="theForm" [formGroup]="theForm">
	<div class="cp-general-width-limit">

		<div class="form-group">
			<label for="userIDs">Additional Users Granted Write Access*</label>
			<ng-select [items]="staffUserSelections" bindValue="id" bindLabel="name" id="userIDs" formControlName="userIDs"
				[multiple]="true" [closeOnSelect]="false">
			</ng-select>
		</div>
		<!-- 
		<div class="form-group mb-0" *ngIf="!saving">
			<button class="btn btn-primary me-1" type="submit" [disabled]="!theForm.valid">
				<fa-icon [icon]="['fas', 'check']"></fa-icon> Save
			</button>
			<button class="btn btn-outline-secondary" type="button" (click)="onCancel()">
				<fa-icon [icon]="['fas', 'times']"></fa-icon> Cancel
			</button>
		</div> -->
	</div>

	<div *ngIf="usersWithAccess.length > 0" class="mt-2">
		The following users have write access to this key via the template:
		<ul>
			<li *ngFor="let u of usersWithAccess">
				{{ u.name }}
			</li>
		</ul>
	</div>

	<div class="cp-form-padding"></div>

	<div *ngIf="!loading && theForm" class="cp-form-buttons">
		<div class="cp-form-buttons-inner">
			<button class="btn btn-primary me-1" type="button" (click)="onSubmit()" [disabled]="!theForm.valid || saving">
				<fa-icon [icon]="ac.actionIcons.submit"></fa-icon> Save
			</button>
			<button class="btn btn-outline-secondary" type="button" (click)="onCancel()" [disabled]="saving">
				<fa-icon [icon]="ac.actionIcons.cancel"></fa-icon> Cancel
			</button>

			<span class="gj-75 ps-2">* Required</span>
		</div>
	</div>

</form>